import styled from 'styled-components';

import Picture from 'components/picture';

export const Outer = styled.div`
  padding: 20px;
`;

export const PictureContainer = styled(Picture)`
  display: flex;
  flex-direction: row;
  height: auto;
  background: ${Styles.color.primary};
  border-radius: 6px;
  ${Styles.desktop`
    height: 300px;
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  padding: 2rem 1rem;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 2rem 1rem 0;
  justify-content: space-between;
`;

export const HeaderBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SideImage = styled(Picture)`
  width: 100%;
`;
